// 英语
const en = {
  描述:"Descriptions",
  图片: 'Photograph',
  名称: 'Name',
  产品编码: 'Product Code',
  总数: 'Aggregate',
  件数: 'Item Count',
  home: 'Home Page',
  用户账号: 'User Account',
  昵称: 'NickName',
  product: 'Product',
  产品分类: 'Product',
  新商品: 'New Products',
  降价产品: 'Price Reduction Products',
  全部分类: 'All Categories',
  返回首页: 'Homepage',
  注册: 'Register',
  我的账户: 'Account',
  我的采购单: 'Orders',
  欢迎光临舱多保产品库: 'Welcome To The Hatch Turbine Product Library',
  你好请登录: 'Hello. Please Log In',
  请输入您想要搜索的内容: 'Please Enter The Content You Want To Search For',
  login: 'Hello, Please Log In',
  search: 'Search',
  exit: 'Exit',
  爆款推荐: 'Hot',
  新产品: 'New Products',
  降价产品: 'Price Reduction Products',
  人付款: 'Person+Payment',
  加入购物车: 'Add To Shopping Cart',
  登录: 'Log In',
  收藏夹: 'Favorites',
  个人中心: 'Individual',
  首页: 'Home Page',
  价格筛选: 'Price',
  更多: 'More',
  由高到低: 'High To Low',
  由低到高: 'Low To High',
  上一页: '<  Previous',
  下一页: 'Next Page  >',
  爆款: 'HOT',
  产品编码: 'Product Code',
  装箱数: 'Cases',
  每箱体积: 'Volume Per Box',
  每箱重量: 'Weight Per Carton',
  分类: 'Classification',
  最小起订箱: 'Minimum Order Box',
  数量: 'Quantity',
  箱: 'Box',
  加入常购清单: 'Frequent Purchase List',
  收藏: 'Collect',
  订单中心: 'Order Center',
  // 我的采购单: 'My purchase order',
  常购清单: 'Frequent Purchase List',
  账户管理: 'Account',
  个人信息: 'Personal Information',
  收货地址: 'Address',
  修改密码: 'Change Password',
  我的留言: 'My Message',
  申请开店: 'Apply To Open A Store',
  全部: 'Whole',
  修改个人信息: 'Modify Personal Information >',
  请输入订单编号: 'Please Enter The Product Order Number',
  商品: 'Commodity',
  单价: 'Unit Price',
  数量: 'Number',
  操作: 'Operate',
  订单号: 'Order No.',
  订单状态: 'Status',
  已下单: 'Ordered',
  处理中: 'In Process',
  已发货: 'Shipped',
  已完成: 'Completed',
  已取消: 'Cancelled',
  订单取消: 'Cancelled',
  已提交: 'Submitted',
  下单时间: 'Order Time',
  支付状态: 'Payment Status',
  待支付: 'Pending Payment',
  已支付: 'Paid',
  交易成功: 'Successful Transaction',
  物流运输中: 'Logistics Transportation',
  订单详情: 'Order Details',
  取消: 'Cancel',
  确认收货: 'Verify',
  订单完成: 'Order Fulfillment',
  订单总额: 'Total Order',
  打印: 'Print',
  导出: 'Derive',
  下载: 'Download',
  配送地址: 'Shipping Address',
  收货地址: 'Shipping Address',
  姓名: 'Name',
  电话号码: 'Telephone',
  公司名称: 'Company',
  邮政编码: 'Postal Code',
  详细地址: 'Address',
  配送: 'Distribution',
  配送方式: 'Distribution Mode',
  货运信息: 'Freight Information',
  船运: 'Shipping',
  空运: 'Air Freight',
  付款方式: 'Payment Method',
  支付信息: 'Payment Information',
  收款公司: 'Collecting Company',
  收款账号: 'Receivables Account',
  收款银行: 'Receiving Bank',
  公司地址: 'Company Address',
  银行地址: 'Bank Address',
  付款凭证: 'Payment Document',
  商品清单: 'Commodity List',
  商品图片: 'Product Picture',
  商品编码: 'Encoding',
  商品名称: 'Name',
  箱数: 'Number Of Cases',
  体积: 'Volume',
  重量: 'Weight',
  金额: 'Amount',
  总重量: 'Gross Weight',
  总体积: 'Bulk Volume',
  总金额: 'Total Amount',
  全选: 'Select All',
  删除: 'Delete',
  批量管理: 'Batch Management',
  导入常购清单: 'Import The Regular Purchase List',
  性别: 'Sex',
  男: 'Male',
  女: 'Female',
  保密: 'Confidentiality',
  出生日期: 'Birth',
  选择日期: 'Select Date',
  头像: 'Avatar',
  邮箱: 'Mailbox',
  个性签名: 'Personal Signature',
  保存: 'Save',
  您已创建: 'You Have Created',
  个收货地址: 'A Shipping Address',
  最多可创建: 'Up To Create',
  个: 'A',
  新增收货地址: 'New',
  手机号码: 'Fax',
  地址: 'Address',
  编辑: 'EDITOR',
  所在地区: 'Local Area',
  请选择: 'Select',
  修改密码: 'Change Password',
  当前密码: 'Current Password',
  新密码: 'New Password',
  确认密码: 'Confirm Password',
  日期: 'Date',
  回复: 'Recover',
  留言: 'Message',
  请输入内容: 'Please Enter Content',
  提交: 'Submit',
  联系人: 'Contact Person',
  联系电话: 'Contact Number',
  手机号码: 'Mobile Phone Number',
  申请入驻: 'Apply For Admission',
  购物车: 'Trolley',
  全部: 'All',
  件: 'A',
  已选择: 'Selected',
  移入收藏夹: 'Move To Favorites',
  去付款: 'Payment',
  结账: 'Settle Accounts',
  选择收货地址: 'Select A Shipping Address',
  管理收货地址: 'Manage Shipping Addresses',
  选择配送方式: 'Select Delivery Method',
  支付信息: 'Payment Information',
  确认: 'Verify',
  留言管理: 'Message Management',
  标题: 'Title',
  留言内容: 'Content',
  请输入用户名: 'Username',
  请输入密码: 'Password',
  忘记密码: 'Forgot Password',
  记住我: 'Remember Me',
  进入官网: 'Enter The Official Website',
  请正确输入邮箱: 'Please Enter The Correct Email Address',
  密码必须是的非空字符: 'The Password Must Be 6-18 Non-Null Characters',
  找回密码: 'Retrieve Password',
  输入请您的邮箱: 'Enter Your Email Address',
  请输入注册邮箱: 'Please Enter Your Registered Email Address',
  下一步: 'Next',
  请正确输入邮箱: 'Please Enter The Correct Email Address',
  验证信息: 'Verification Information',
  设置新密码: 'Set A New Password',
  重置成功: 'Reset Successfully',
  验证码已发送至: 'Sent To',
  请输入邮箱内验证码进行重置密码: 'Please Enter The Verification Code',
  请输入验证码: 'Please Enter The Verification Code',
  发送验证码: 'Send',
  重新发送: 'Retransmission',
  验证码不能为空: 'The Verification Code Cannot Be Empty',
  两次输入的密码不一致: 'The Two Passwords Are Different',
  请再次输入密码: 'Please Enter Your Password Again',
  恭喜您密码重置成功快去登录吧:
    'Congratulations On The Successful Password Reset, Go To Login',
  登陆: 'Log In',
  商品详情: 'Product Details',
  推荐商品: 'Recommended Goods',
  成功加入收藏夹: 'Added To Favorites Successfully',
  成功加入常购清单: 'Successfully Added To The Frequent Purchase List',
  添加成功: 'Add Successfully',
  您还未登录即将跳转登录页面:
    'You Are Not Logged In And Will Be Redirected To The Login Page',
  请选择商品再结算: 'Please Select The Item To Be Resettled',
  下单成功: 'Order Successful',
  请输入留言标题: 'Please Enter The Message Title',
  请输入留言内容: 'Please Enter The Message Content',
  提交成功: 'Submit Successfully',
  修改成功: 'Modified Successfully',
  密码修改成功即将重新登录:
    'The Password Is Changed Successfully. You Are About To Log In Again',
  请检查当前密码输入是否正确:
    'Please Check Whether The Current Password Is Correct',
  回复成功: 'Reply Successfully',
  请输入回复内容: 'Please Enter The Reply Content',
  上传头像图片只能是JPGJPEGPNG格式:
    'Upload A Profile Picture In JPG、JPEG、PNG Format Only!',
  上传头像图片大小不能超过2MB:
    'The Size Of The Uploaded Profile Picture Cannot Exceed 2MB',
  请输入姓名: 'Please Enter Your Name',
  请输入出生年月日: 'Please Enter The Date Of Birth',
  请上传头像: 'Please Upload Photo',
  请输入公司名称: 'Please Enter The Company Name',
  请输入电话号码: 'Please Enter The Phone Number',
  请输入个性签名: 'Please Enter Your Personal Signature',
  请选择性别: 'Please Select Gender',
  请输入邮箱: 'Please Enter Email',
  个人信息保存成功: 'Personal Information Saved Successfully',
  您的入驻申请通过: 'Your Application Is Accepted',
  您的入驻申请正在审核中: 'Your Application Is Under Review',
  您的入驻申请未通过未通过的原因为:
    'The Reason Why Your Application Was Not Approved Is',
  请输入手机号码: 'Please Enter Your Mobile Number',
  请输入联系电话: 'Please Enter A Contact Number',
  请输入联系人: 'Please Enter Contact Person',
  您的开店申请以提交请等待审核:
    'Your Application To Open A Store For Submission Is Pending Review',
  邮箱注册: 'Email Registration',
  微信: 'WeChat',
  电话: 'Phone',
  回顶部: 'Upper',
  打开微信: 'Open Wechat',
  扫码添加客服: 'Scan The Code',
  综合: 'Synthesis',
  销量: 'Sales',
  新品: 'New',
  价格: 'Price',
  更多: 'More',
  请上传文件材料: 'Upload Files',
  舱多保供应链版权所有: 'All Rights Reserved For Chaiduobao Supply Chain',
  您的订单已经处理成功订单号:
    'Your Order Has Been Processed Successfully Order Number',
  查看订单: 'View Order',
  导入购物车: 'Import Cart',
  销量筛选: 'Sales Filter',
  MOQ: '',
  SetS: '',
  共有: 'Total',
  转到购物车: 'Go To Cart',
  生成采购单: 'Generate Purchase Orders',
  暂无发货清单:'No Shipping List',
  发货清单:'Shipping List',
  导出Excel: 'Export Excel',
  符号:'$',
  language: {
    zh: '中文',
    en: 'English',
    es: 'Español',
    por: 'Português'
  }
}
export default en
